<template>
  <div
    class="calendar"
    @click="$emit('day')"
  >
    <div class="panel">
      <header class="header">
        <p class="header-title">Kalender</p>
        <h3 class="month">{{ currentMonth }}</h3>
      </header>
      <div
        class="dates"
        v-if="rows"
      >
        <div
          class="row"
          v-for="(row, index) in rows"
          :key="index"
        >
          <div
            class="col"
            v-for="(col, jndex) in row"
            :key="jndex"
            :class="{
              'disabled': col === 0,
              'active': col === currentDay
            }"
          >
            <span
              v-if="col === currentDay"
              class="number"
              @click="goToDay"
            >
              {{ col }}
            </span>
            <span
              v-else
              class="number"
            >
              {{ col }}
            </span>
          </div>
        </div>
      </div>
      <footer class="footer">
        <p class="full-date">{{ fullDate }}</p>
        <h2 class="title">Thee drinken met buuf</h2>
      </footer>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { trackAlarm } from '@/utils/track'

export default {
  name: 'Calendar',
  computed: {
    rows () {
      let currRows = [[]]
      let startRow = 0

      // Number of day (0 (Monday) to 6 (Friday))
      const startDayNum = moment().startOf('month').format('d')
      // Days in current month
      const daysInMonth = moment().daysInMonth()

      for (let i = 0; i < startDayNum - 1; i++) {
        currRows[startRow].push(0)
      }
      for (let i = 1; i < daysInMonth + 1; i++) {
        if (currRows[startRow].length === 7) {
          currRows.push([])
          startRow++
        }
        currRows[startRow].push(i)
      }

      return currRows
    },
    currentDay () {
      return moment().date()
    },
    currentMonth () {
      return moment().locale('nl').format('MMMM')
    },
    fullDate () {
      return moment().locale('nl').format('dddd D MMMM')
    }
  },
  methods: {
    goToDay () {
      this.$emit('day')
      trackAlarm('date-clicked')
    }
  },
  mounted () {
    // If the user still hasn't clicked on the pulsating date
    // Just emit the 'day' event
    // Closes the Calendar and shows the DayDetail component
    setTimeout(() => this.$emit('day'), 5000)
  }
}
</script>

<style lang="scss" scoped>
.calendar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 26px 14px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  transition: all .3s ease;
  z-index: 100;
}
.panel {
  background-color: white;
  width: 100%;
  max-width: 345px;
  border-radius: 5px;
  position: relative;
}
.header {
  border-bottom: 1px solid #EFF0F6;
  padding: 4px 30px 15px 30px;
}
.header-title {
  font-size: 18px;
  line-height: 3;
  color: $c-dark;
}
.close {
  position: absolute;
  z-index: 1;
  right: 18px;
  top: 24px;
  outline: 0;
  background-color: transparent;
  border: none;
  outline: 0;
  cursor: pointer;
  padding: 0;
  margin: 0;
}
.cross {
}
.month {
  color: $c-red;
  text-align: left;
  font-weight: $fw-semi;
  font-size: 32px;
  text-transform: lowercase;
}
.dates {
  padding-left: 15px;
  padding-right: 15px;
}
.row {
  @extend %clearfix;
  padding-top: 25px;
  padding-bottom: 25px;

  @media (max-height: 600px) {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .col {
    &:first-child, &:nth-child(7) {
      color: #9E9E9E;
    }
  }
}
.col {
  @extend %col;
  width: 14.2857142857%;
  text-align: center;
  font-size: 15.84px;
  color: black;
}
.disabled {
  opacity: 0;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba($c-red, 0.8);
  }
  70% {
    box-shadow: 0 0 0 25px rgba($c-red, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba($c-red, 0);
  }
}

.active {
  color: white !important;
  position: relative;
  height: 15px;

  &:after {
    content: '';
    position: absolute;
    z-index: 0;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 45px;
    height: 45px;
    background-color: $c-red;
    box-shadow: 0 0 0 rgba($c-red, 0.8);
    animation: pulse 1s infinite;

    @media (max-height: 600px) {
      width: 37px;
      height: 37px;
    }
  }

  .number {
    position: relative;
    z-index: 1;
    cursor: pointer;
  }
}
.number {
  line-height: 1;
  font-weight: $fw-medium;
}
.footer {
  border-top: 1px solid #EFF0F6;
  padding: 25px 30px 30px 30px;
  text-align: left;
}
.full-date {
  color: $c-red;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: $fw-medium;
}
.title {
  font-size: 26px;
  color: $c-dark;
  font-weight: $fw-bold;
  line-height: 1.23;
}
</style>



// WEBPACK FOOTER //
// src/components/alarm/Calendar.vue